import { Form } from '@unform/web'
import { IoLogoWhatsapp } from 'react-icons/io'
import { theme } from 'src/styles/themes/default'
import styled from '@emotion/styled'
import GInput from '../inputs/gInput'
import Link from 'src/components/Link'

interface ContainerProps {
  isMobile?: boolean
}

export const AccessYourAccountContent = styled.label`
  text-align: center;
`

export const ButtonSubmit = styled.button`
  background-color: ${theme.success.main};
  border-radius: 0.375rem;
  border: 0.125rem solid ${theme.success.main};
  color: ${theme.colors.white};
  font-weight: 600;
  height: 3.5rem;
  letter-spacing: -0.0071rem;
  text-transform: uppercase;
  transition: all 0.3s;
  width: 100%;
  &:hover {
    color: ${theme.success.main};
    background-color: transparent;
    transition: all 0.3s;
  }
`

export const Container = styled.main<ContainerProps>`
  align-items: center;
  display: flex;
  justify-content: center;
  padding-bottom: 6.0625rem;
  padding-top: 2.5rem;

  @media (max-width: 75rem) {
    padding: 2.5rem 0rem;
  }
`

export const ContainerContent = styled.div`
  h2 {
    font-size: 1.25rem;
    line-height: 1.625rem;
    text-align: center;
    color: #363843;
    margin-bottom: 0.625rem;
  }

  .info-form {
    display: block;
    text-align: center;
    font-size: 0.875rem;
    line-height: 1.0625rem;
    color: #646981;
  }
  form {
    margin-top: 2rem;
  }
  @media (max-width: 75rem) {
    padding: 2.5rem 0;
  }
  @media (max-width: 30rem) {
    h2 {
      max-width: 15.625rem;
      margin: 0 auto;
      margin-bottom: 0.9375rem;
    }
  }
`

export const Content = styled.div`
  width: 29.1875rem;
  padding: 0 0.9375rem;

  @media (max-width: 75rem) {
    width: 100%;
  }
`

export const FormContainer = styled(Form)`
  margin-top: 1.125rem;
  padding: 1rem 1rem 0.5rem 1rem;
`

export const GInputContent = styled(GInput)`
  border-radius: 0.375rem;
  color: ${theme.colors.grey[300]};
  position: relative;
  font-size: 0.875rem;
  height: 3.375rem;
  padding: 0rem 1.125rem;
  width: 100%;
  &::placeholder {
    color: #a0a4b3;
  }
  &[name='email'] {
    text-transform: lowercase;
  }
`

export const InputContent = styled.div`
  margin-bottom: 1.5rem;
  position: relative;
`

export const InfoForm = styled.span`
  color: ${theme.colors.grey[300]};
  display: block;
  font-size: 0.875rem;
  line-height: 1.0625rem;
  text-align: center;
`

export const Label = styled.label`
  clear: left;
  color: ${theme.colors.grey[100]};
  display: block;
  font: normal 500 0.875rem/1.0625rem 'Inter';
  margin-bottom: 0.6875rem;
`

export const PolicyPrivacyContent = styled.div`
  text-align: center;
`

export const PolicyPrivacyLink = styled(Link)`
  font-size: 0.875rem;
`

export const Title = styled.h2`
  color: ${theme.colors.grey[100]};
  font-size: 1.25rem;
  line-height: 1.625rem;
  margin-bottom: 0.625rem;
  text-align: center;

  @media (max-width: 30rem) {
    h2 {
      max-width: 15.625rem;
      margin: 0 auto;
      margin-bottom: 0.9375rem;
    }
  }
`

export const WhatsApp = styled.text`
  font-family: 'Inter';
  font-size: 0.8125rem;
  font-style: normal;
  font-weight: bold;
  letter-spacing: -0.0063rem;
  line-height: 1.0625rem;
  margin-left: 1.6rem;
  text-align: center;
`

export const WhatsAppLogoContent = styled(IoLogoWhatsapp)`
  margin-left: 0.3em;
  position: absolute;
`
